export default "__VITE_ASSET__CnxFF7zk__"